import React, { useState, useMemo, useRef } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import {
  showTimeByDateType,
  getDataSourcesMetricsByTopChartsType,
  formatNum,
  updateURLSearchParams,
} from '@/pages/intelligence/utils/commonUtils';
import { ECHARTSCOLOR, SteamSalesList } from '@/pages/intelligence/utils/echartsConst';
import DataSourceMetricSelector from '@/pages/intelligence/components/ChartsComponents/DataSourceMetricSelector';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import {
  handlePriceFormat,
  valueFormatter,
  severalMathFormat,
} from '@/pages/intelligence/utils/echartsUtils';
import useSinglePieCharts from '@/pages/intelligence/components/Chart/hooks/useSinglePieCharts';
import { connect, getLocale } from 'umi';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { Segment } from 'tea-component';
import { toActiveUsersTag, getIfPercentage } from '@/pages/intelligence/utils/common';
import type { IChartsIndexInstance } from '@intelligence/components/ChartsComponents/ChartsIndex';
import {
  MetricsTablePageIds,
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
  SourceDataMap,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import useMetricsOptionsDisabledEffect from '../../MetricsTable/_hooks/useMetricsOptionsDisabledEffect';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import {
  dbiTopChartsBtnLogMes,
  soureInfo,
} from '@/pages/intelligence/utils/topChartsBuriedPointCfg';
import Loading from '@/pages/intelligence/components/Loading';
import { ChangeSegementFunType } from '@intelligence/components/ChartsComponents/DataSourceMetricSelector';
import { useDeepCompareEffect } from 'ahooks';
import moment from 'moment';
import { URL_CHART_METRIC } from '@intelligence/utils/urlPathCfg';
const metricsFieldName = 'metric_list';
const metricsFieldNameForLine = 'metric_value_list';

// 每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const MetricsTableVisualis: React.FC<any> = (props: any) => {
  const {
    entityType,
    chartType = ChartType.Bar,
    dateType = 'Month',
    startDate,
    endDate,
    metric,
    setMetric,
    defaultMetric,
    imageType,
    lineData = [], // 折线 数据
    isNodata,
    fetchParams,
    barOrPieData,
    topChartsType,
    pageId,
    topchartsState,
    dispatch,
    handleChartMetricType,
    formatMessage,
    noSuitableMsg,
    metricSegVal,
    setMetricSegVal,
    setNoSuitableMsg,
    sortByKey,
    dataSourcesColumns,
    gameHightList = [],
    isStudio = false,
    handleChangeSegement,
    isVisualisLoading,
    visualLoadingHeight,
    pageIdToLine = '',
    useMarketFilterApiKey = '',
  } = props;

  // console.log('MetricsTableVisualis', props);

  const isPCConsoleCombine = imageType === PC_CONSOLE_COMBINE_ENTITY_TYPE;

  const locale = getLocale();

  const cardRef = useRef({} as any);
  const chartsInstance = useRef<IChartsIndexInstance>(null);
  const [chartLoading, setChartLoading] = useState(true);
  const [metricName, setMetricName] = useState(
    defaultMetric?.length > 0 ? defaultMetric[0].text : '',
  );
  const dataSourcesMetrics = getDataSourcesMetricsByTopChartsType(topChartsType);
  const [dataSourceMetricsOptions, setDataSourceMetricsOptions] =
    useState<any[]>(dataSourcesMetrics);

  const [metricSegValText, setMetricSegValText] = useState(SteamSalesList[0].text);

  // 可视化 数据源指标筛选器 禁用交互逻辑
  useMetricsOptionsDisabledEffect({
    entityType: imageType,
    pageId,
    topChartsType,
    isPCConsoleCombine,
    fetchParams,
    dataSourcesColumns,
    dataSourceMetricsOptions,
    setDataSourceMetricsOptions,
  });

  // 可视化暂时只处理单个高亮游戏
  const gameHighId = useMemo(() => {
    if (Array.isArray(gameHightList) && gameHightList?.length > 0) {
      return gameHightList[0];
    }
    return '';
  }, [gameHightList]);

  // 转换成国家堆叠图需要的数据结构
  // 玩家市场分布 segment 已切换到 alinea__players_by_country（见 SteamSalesList），
  // 这里的 stacked-bar 渲染分支需要同步识别新的 metricSegVal，否则会回落到空的通用 bar 渲染。
  const stackBarData = useMemo(() => {
    if (pageId == 'SteamSales' && metricSegVal == 'alinea__players_by_country' && chartType == 'bar') {
      const arrList: any = [];
      if (Array.isArray(barOrPieData) && barOrPieData?.length > 0) {
        barOrPieData?.map((item: any): any => {
          const metricList =
            item.metric_list?.find((item: any) => item.title == metricSegVal) || {};
          const dataList = metricList.history || [];
          const lastTime = metricList.latest_time || '';
          arrList.push({
            app_id: item.app_id,
            metrics: dataList,
            name: item.name,
            cover: item.cover,
            lastTime,
          });
        });
      }
      return arrList;
    }
    return [];
  }, [barOrPieData, metricSegVal, chartType, pageId]);

  const stackBarDataNameList = useMemo(
    () => stackBarData?.map((item: { name: any }) => item?.name) || [],
    [stackBarData],
  );

  const valueIsNull = (value: any) => value === '' || value === null || value === undefined;

  const calVal = (value: any, data: any) => {
    const calVal = valueIsNull(value) ? 0 : value;
    let sum = 0;
    data?.forEach((item: any) => {
      const itemVal = valueIsNull(item?.value) ? 0 : item?.value;
      sum = sum + itemVal;
    });
    return sum == 0 ? 0 : ((calVal / sum) * 100).toFixed(1);
  };

  /** 获取接口里指定卡片标签的数据 */
  const getMetricData = (data: any, segment: string) => {
    const keys = data || [];
    for (let i = 0; i < keys?.length; i++) {
      if (keys[i].title === segment) {
        return keys[i];
      }
    }
    return {};
  };

  const stackBarSeriesData = useMemo(() => {
    const _barSeries: any = [];
    const _barxAxis: any = [];
    const _legendData: any = [];
    const coverList: any = [];

    if (pageId == 'SteamSales' && metricSegVal == 'alinea__players_by_country' && chartType == 'bar') {
      if (!Array.isArray(barOrPieData) || !barOrPieData?.length) {
        return {
          xAxis: [],
          series: [],
          legend: [],
        };
      }
      // 想排序要在处理前排序
      barOrPieData?.forEach((item) => {
        _barxAxis.push(item?.name);
        coverList.push(item?.cover);
        _legendData.push({
          gameName: item?.name,
          cover: item?.cover,
          useGameName: true,
        });
      });

      if (!Array.isArray(stackBarData)) {
        return _barSeries;
      }

      // 想排序要在处理前排序
      const sourceList = ['country1', 'country2', 'country3', 'country4', 'country5', 'others'];
      sourceList.forEach((item, index) => {
        const dataVal: any = []; // 通过下标拿值
        barOrPieData?.forEach((t) => {
          const _currentSegData = getMetricData(t?.metric_list, metricSegVal);
          // TODO，计算出百分比值(算法不准，有99.9， 有100.1)
          const countryItem = Array.isArray(_currentSegData?.history)
            ? _currentSegData?.history[index]
            : null;
          const percent = calVal(countryItem?.value, _currentSegData?.history);
          dataVal.push({
            value: percent,
            name: countryItem?.market,
            market: countryItem?.market_en,
            percent: valueIsNull(countryItem?.value) ? '-' : `${percent}%`,
            latest_time: _currentSegData?.latest_time, // 最新一天（时间）
            cover: t.cover,
          });
        });

        _barSeries.push({
          name: item,
          type: 'bar',
          stack: 'total',
          data: dataVal,
          barMaxWidth: 92,
          useGameName: true,
          gameName: _barxAxis[index],
          cover: coverList[index],
        });
      });
    }
    return _barSeries;
  }, [barOrPieData, metricSegVal, chartType, pageId]);

  const metricCur = useMemo(() => {
    if (pageId === 'SteamSales') {
      return metricSegVal;
    }
    if (!MetricsTablePageIds.includes(pageId) && topchartsState.metricValue != '') {
      return topchartsState.metricValue;
    }
    return metric;
  }, [pageId, metric, topchartsState.metricValue, metricSegVal]);

  const barOrPieDataCur = useMemo(() => {
    if (Array.isArray(barOrPieData) && barOrPieData?.length > 0 && isStudio) {
      // 判断当前metricCur是否有匹配
      if (barOrPieData[0]?.metric_list?.findIndex((item: any) => item.title === metricCur) > -1) {
        const newDataList = [...barOrPieData];
        newDataList.sort((a: any, b: any) => {
          const metricObjA = a?.metric_list?.find((item: any) => item.title === metricCur);
          const metricObjB = b?.metric_list?.find((item: any) => item.title === metricCur);
          const valueTempA = metricObjA?.value || 0;
          const valueTempB = metricObjB?.value || 0;
          return valueTempB - valueTempA;
        });
        return newDataList;
      }
      return barOrPieData;
    }
    return barOrPieData;
  }, [barOrPieData, metricCur]);

  const barNameList = useMemo(
    () => barOrPieDataCur?.map((item: { name: any }) => item?.name) || [],
    [barOrPieDataCur],
  );

  // metricName 值，根据当前 metric 获取
  useDeepCompareEffect(() => {
    // 根据当前 metric 获取对应的 metricName
    let metricText;
    if (metricCur) {
      for (const item of dataSourceMetricsOptions) {
        // segment 选项
        if (item.value === metricCur) {
          metricText = item?.text;
          setMetricName(metricText);
          break;
        }

        // metrics 下拉选项
        const metricObject = item.children?.find(
          (subItem: { value: string }) => subItem.value === metricCur,
        );
        if (metricObject?.text) {
          metricText = metricObject?.text;
          setMetricName(metricText);
          break;
        }
      }
    }

    if (metricText) return;

    // 如果无未获取到 metric 对应信息，指定兜底默认值
    const currentOptions = dataSourceMetricsOptions?.find((item) => !item.disabled);
    if (currentOptions?.children?.length) {
      const currentMetric = currentOptions.children?.find((item: any) => !item.disabled) || {};
      setMetricName(currentMetric.text);
    }
  }, [dataSourceMetricsOptions, metricCur]);

  const metricNameCur = useMemo(() => {
    if (pageId == 'SteamSales' && metricSegValText) {
      return formatMessage({ id: metricSegValText });
    }

    if (!MetricsTablePageIds.includes(pageId) && topchartsState.metricCurName != '') {
      return formatMessage({ id: topchartsState.metricCurName });
    }

    return formatMessage({ id: metricName });
  }, [pageId, metricName, topchartsState.metricCurName, locale, metricSegValText]);

  const metricText = useMemo(() => {
    const currentSource = dataSourceMetricsOptions?.find(
      (item: any) =>
        item?.value === metricCur ||
        item?.metric?.value === metricCur ||
        item?.children?.some((subItem: any) => subItem?.value === metricCur),
    );
    return currentSource?.text;
  }, [dataSourceMetricsOptions, metricCur]);

  const findMetricDetail = (data: any, metricValue: string) => {
    if (!data) return null;
    const _metricsFieldName = chartType == 'line' ? metricsFieldNameForLine : metricsFieldName;
    const metrics = data[_metricsFieldName] || [];

    return metrics?.find((item: any) => item.title === metricValue) || null;
  };

  const getMetricBaseValue = (metricValue: string) => {
    if (typeof metricValue !== 'string') {
      return '';
    }

    const parts = metricValue.split('__');
    if (parts.length <= 1) {
      return metricValue;
    }

    return parts.slice(1).join('__');
  };

  const hasChartValue = (value: any) => {
    if (valueIsNull(value)) {
      return false;
    }

    return !Number.isNaN(Number(value));
  };

  const findFallbackLineMetric = (metricValue: string) => {
    const metricBaseValue = getMetricBaseValue(metricValue);
    let firstMetricWithValue = '';

    for (const data of lineData || []) {
      const metricValueList = data?.metric_value_list || [];
      for (const item of metricValueList) {
        if (!hasChartValue(item?.value)) {
          continue;
        }

        if (!firstMetricWithValue) {
          firstMetricWithValue = item?.title || '';
        }

        if (metricBaseValue && getMetricBaseValue(item?.title) === metricBaseValue) {
          return item?.title || '';
        }
      }
    }

    return firstMetricWithValue;
  };

  const normalizeSourceKey = (rawSource: any) => {
    console.log(rawSource);
    if (typeof rawSource !== 'string') return '';
    const trimmed = rawSource.trim().toLowerCase();
    if (!trimmed) return '';

    const candidates: string[] = [];
    const pushCandidate = (val?: string) => {
      if (!val) return;
      const clean = val.trim();
      if (clean && !candidates.includes(clean)) candidates.push(clean);
    };

    pushCandidate(trimmed);
    pushCandidate(trimmed.replace(/\s+/g, ''));
    pushCandidate(trimmed.split('__')[0]);
    pushCandidate(trimmed.split('_')[0]);
    pushCandidate(trimmed.replace(/[^a-z]/g, ''));

    const keywordMap: [string, string][] = [
      ['databrain', 'databrain'],
      ['data_brain', 'databrain'],
      ['true_data', 'databrain'],
      ['truedata', 'databrain'],
      ['mscience', 'mscience'],
      ['npd', 'npd'],
      ['gsd', 'gsd'],
      ['gamalytic', 'gamalytic'],
      ['vginsights', 'vginsights'],
      ['vginsight', 'vginsights'],
      ['sensortower', 'sensortower'],
      ['appannie', 'appannie'],
      ['ogdb', 'ogdb'],
      ['steamcharts', 'steamcharts'],
      ['steam', 'steam'],
    ];

    for (const candidate of candidates) {
      if (SourceDataMap[candidate]) return candidate;
    }

    for (const [keyword, normalized] of keywordMap) {
      if (trimmed.includes(keyword)) return normalized;
    }

    return candidates[0] || trimmed;
  };

  const resolveDataSourceInfo = (metricDetail: any) => {
    const rawSource =
      metricDetail?.data_source ||
      metricDetail?.source ||
      metricDetail?.order_source ||
      metricDetail?.tableSource ||
      metricDetail?.dataSource ||
      metricDetail?.orderSource ||
      '';
    let normalizedSourceKey = rawSource ? normalizeSourceKey(rawSource) : '';

    if (!normalizedSourceKey) {
      normalizedSourceKey = normalizeSourceKey(metricDetail?.metric || '');
    }

    if (!normalizedSourceKey) {
      normalizedSourceKey = normalizeSourceKey(metricDetail?.tableSource || '');
    }

    if (!normalizedSourceKey) {
      normalizedSourceKey = normalizeSourceKey(fallBackMetricSource.key || '');
    }

    if (!normalizedSourceKey) {
      normalizedSourceKey = normalizeSourceKey(metricCur);
    }

    const displaySourceName =
      metricDetail?.dataSourceName ||
      (normalizedSourceKey ? SourceDataMap[normalizedSourceKey] || rawSource : rawSource) ||
      fallBackMetricSource.name;

    return {
      key: normalizedSourceKey,
      name: displaySourceName,
      raw: rawSource,
    };
  };

  const fallBackMetricSource = useMemo(() => {
    const matchedMetric =
      dataSourcesColumns?.find(
        (item: any) =>
          item?.value === metricCur ||
          item?.metricValue === metricCur ||
          item?.metricKey === metricCur ||
          item?.source_metric === metricCur,
      ) || {};

    const sourceKeyCandidate =
      matchedMetric?.metricValue ||
      matchedMetric?.tableSource ||
      matchedMetric?.dataSource ||
      matchedMetric?.source ||
      matchedMetric?.orderSource ||
      '';

    const normalizedSourceKey =
      typeof sourceKeyCandidate === 'string' ? sourceKeyCandidate.trim().toLowerCase() : '';

    const sourceName =
      normalizedSourceKey && SourceDataMap[normalizedSourceKey]
        ? SourceDataMap[normalizedSourceKey]
        : sourceKeyCandidate;

    return {
      key: normalizedSourceKey,
      name: sourceName,
    };
  }, [dataSourcesColumns, metricCur]);

  const getMetrisDatasValue = (data: any, metricValue: string, ifPercentage: boolean) => {
    const metricObj = findMetricDetail(data, metricValue);
    if (!metricObj) {
      return null;
    }

    if (chartType === ChartType.Line && !hasChartValue(metricObj?.value)) {
      return null;
    }

    const valueTemp = metricObj?.value;
    if (valueIsNull(valueTemp)) {
      return null;
    }

    return ifPercentage ? valueTemp * 100 : valueTemp;
  };

  const getPCConsoleMetricsValue = (data: any, ifPercentage: boolean) => {
    if (!data) return null;
    const valueTemp = data?.value || 0;
    if (valueTemp || chartType !== 'line') {
      return ifPercentage ? valueTemp * 100 : valueTemp;
    }
    return null;
  };

  const metricValueFormatter = (params: any) => {
    if (metricCur === 'gamalytic__est_price' || metricCur === 'gamalytic__weighted_price') {
      return handlePriceFormat(params.value);
    }
    if (metricCur === 'alinea__players_by_country') {
      return params?.value ? `${formatNum(params?.value)}%` : '-';
    }
    let value: any = Number(params.value);
    value = Number.isNaN(value) ? 0 : value;
    if (valueFormatter instanceof Function) {
      value = valueFormatter(value, metricCur);
    } else {
      value = severalMathFormat(value, true);
    }
    return value;
  };

  // 通用柱状图数据格式
  const barSeriesData = useMemo(
    () =>
      barOrPieDataCur?.map((item: any, i: number): any => {
        const metricDetail = findMetricDetail(item, metricCur) || {};
        const { key: dataSourceKey, name: dataSourceNameResolved, raw: rawSource } =
          resolveDataSourceInfo(metricDetail);
        return {
          type: 'bar',
          name: item.name,
          value: getMetrisDatasValue(item, metricCur, getIfPercentage(metricCur)),
          cover: item.cover,
          dataSourceKey,
          dataSourceName: dataSourceNameResolved,
          itemStyle: {
            color: ECHARTSCOLOR[i],
          },
          label: {
            show: true,
            position: 'top',
            color: '#444',
            distance: 4,
            fontSize: 12,
            formatter: metricValueFormatter,
          },
        };
      }),
    [barOrPieDataCur, metricCur, chartType, sortByKey],
  );

  // 通用饼图数据格式
  const pieSeriesData = useMemo(() => {
    const arrList: any = [];
    if (Array.isArray(barOrPieData) && barOrPieData?.length > 0) {
      barOrPieData?.map((item: any): any => {
        let pieObj = {
          app_id: item.unified_id,
          name: item.name,
          value: getMetrisDatasValue(item, metricCur, getIfPercentage(metricCur)),
          cover: item.cover,
        } as any;
        if (item.unified_id == gameHighId) {
          pieObj = {
            ...pieObj,
            label: {
              color: '#262832',
              fontWeight: 'bold',
            },
          };
        }
        arrList.push(pieObj);
      });
    }
    return arrList;
  }, [barOrPieData, metricCur, chartType]);

  const pieDataHighIndex = useMemo(
    () => pieSeriesData?.findIndex((item: any) => item.app_id == gameHighId),
    [pieSeriesData, gameHighId],
  );

  const getCommonTypeData = (game: any, metricCur: string) => {
    const arr: any = [];
    const list = lineData?.filter((item: any) => item.name == game.name);
    list?.forEach((item: any) => {
      const metricDetail = findMetricDetail(item, metricCur) || {};
      const valueNum = getMetrisDatasValue(item, metricCur, getIfPercentage(metricCur));
      if (!valueIsNull(valueNum)) {
        const { key: dataSourceKey, name: dataSourceName, raw } = resolveDataSourceInfo(metricDetail);
        arr.push({
          time: dateType ? showTimeByDateType(item.time, dateType?.toLocaleLowerCase()) : item.time,
          value: valueNum,
          dataSourceKey,
          dataSourceName,
          rawSource: raw,
          metric: metricCur,
        });
      }
    });
    return arr;
  };

  const getPCConsoleMetricsLineData = (game: any, metricCur: string) => {
    const arr: any = [];
    const metricList = game?.metric_value_list || [];
    const list = metricList?.filter((item: any) => item.metric === metricCur);
    // 按时间排序
    list.sort((a: any, b: any) => moment(a.date).valueOf() - moment(b.date).valueOf());
    list?.forEach((item: any) => {
      const valueNum = getPCConsoleMetricsValue(item, getIfPercentage(metricCur));
      if (valueNum) {
        const { key: dataSourceKey, name: dataSourceName, raw } = resolveDataSourceInfo(item);
        arr.push({
          time: dateType ? showTimeByDateType(item.date, dateType?.toLocaleLowerCase()) : item.date,
          value: valueNum,
          dataSourceKey,
          dataSourceName,
          rawSource: raw,
          metric: metricCur,
        });
      }
    });
    return arr;
  };

  const gameDataList = useMemo(() => {
    const gameNames: string[] = [];
    const gameDataList: any[] = [];
    if (Array.isArray(lineData) && lineData?.length > 0) {
      /** 获取gameNames集合 */
      lineData?.forEach((game: any) => {
        if (!game) return;
        if (!gameNames.includes(game.name)) {
          gameNames.push(game.name);
          gameDataList.push(game);
        }
      });
    }
    return gameDataList;
  }, [lineData]);

  const lineMetricCur = useMemo(() => {
    if (chartType !== ChartType.Line) {
      return metricCur;
    }
    const hasCurrentMetricData = lineData?.some((item: any) => {
      return hasChartValue(findMetricDetail(item, metricCur)?.value);
    });
    if (hasCurrentMetricData) {
      return metricCur;
    }
    return findFallbackLineMetric(metricCur) || metricCur;
  }, [chartType, lineData, metricCur]);

  const isStepLine = useMemo(() => {
    if (
      toActiveUsersTag[dateType] === 'DAU' &&
      (metricSegVal === 'gamalytic__est_price' || metricSegVal === 'gamalytic__weighted_price')
    ) {
      return true;
    }
    return false;
  }, [dateType, metricSegVal]);

  // 组装通用拆线图数据格式
  const lineSeriesData = useMemo(() => {
    const arrGameData: any = [];
    if (pageIdToLine === 'PCConsoleMetricsTableToLine' || pageIdToLine === 'PCConsoleDataBrainCalibrationToLine') {
      gameDataList?.forEach((item: any) => {
        const gameObj = item;
        const objTemp = {
          cover: gameObj.cover,
          id: gameObj.id,
          name: gameObj.name,
          history: getPCConsoleMetricsLineData(gameObj, metricCur),
        };
        arrGameData.push(objTemp);
      });
    } else {
      gameDataList?.forEach((item: any) => {
        const gameObj = item;
        const objTemp = {
          cover: gameObj.cover,
          id: gameObj.unified_id,
          name: gameObj.name,
          history: getCommonTypeData(gameObj, lineMetricCur),
        };
        arrGameData.push(objTemp);
      });
    }
    const temp = {
      source: Array.isArray(arrGameData) ? arrGameData : [],
    };
    return temp;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameDataList, lineMetricCur, metricCur, pageIdToLine]);

  const isPercentMode = useMemo(() => {
    return getIfPercentage(metricCur) || metricSegVal == 'alinea__players_by_country';
  }, [metricSegVal, metricCur]);

  // 获取柱状图hooks
  const { barOption } = useBarCharts({
    showTitle: false,
    title: metricCur,
    seriesData: metricSegVal == 'alinea__players_by_country' ? stackBarSeriesData : barSeriesData,
    setChartLoading,
    barOrPieData: barOrPieDataCur,
    titleNow: metricNameCur,
    barNameList: metricSegVal == 'alinea__players_by_country' ? stackBarDataNameList : barNameList,
    topChartsType:
      metricSegVal == 'alinea__players_by_country'
        ? 'steamSales—players_by_country-topcharts'
        : 'pcMetricsTable',
    cardWidth: cardRef?.current?.clientWidth,
    imageType,
    barCurSeries: metricSegVal == 'alinea__players_by_country' ? stackBarSeriesData : [],
    isStackBar: metricSegVal == 'alinea__players_by_country',
    ifPercentage: isPercentMode,
    startDate,
    endDate,
    timeText: metricSegVal == 'alinea__players_by_country' ? formatMessage({ id: 'dbi_top_asof' }) : '',
    valueFormatter: metricValueFormatter,
    barListValue: MetricsTablePageIds.includes(pageId) ? formatMessage({ id: metricText }) : '',
    gameHighId,
    useMarketFilterApiKey,
  });
  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineData: lineSeriesData, // 折线 数据
    dateType,
    topChartsType: pageIdToLine?.includes('DataBrainCalibration') ? 'pcDataBrainCalibration' : 'pcMetricsTable',
    imageType,
    titleNow: metricNameCur,
    metric: 'source',
    isStep: isStepLine,
    isPercentLine: isPercentMode,
    isNaNeedMax: !isPercentMode,
    gameHighId,
  });

  // 获取饼图hooks
  const { pieOption } = useSinglePieCharts({
    pieData: pieSeriesData,
    pieTitle: metricNameCur,
    chartLoading,
    setChartLoading,
    chartType,
    chartsInstance,
    titleNow: metricNameCur,
    startDate,
    endDate,
    gameHighId,
  });

  const handleMetricChange = (params: ChangeSegementFunType) => {
    // console.log('handleMetricChange-params', params);
    // console.log('steamSalesList', steamSalesList);

    const { metric: value, source, metricname, isChange } = params || {};
    if (isChange) {
      handleChangeSegement(params);
    }
    setMetric(value);
    dispatch({ type: `${DBI_TOPCHARTS}/setMetricValue`, payload: value });
    dispatch({ type: `${DBI_TOPCHARTS}/setMetricCurName`, payload: metricname });
    setMetricName(metricname);
    // 埋点
    const metricLogKey = `${entityType}_${pageId}_topChartsMetricsSelector`;

    const logConfig = dbiTopChartsBtnLogMes?.[metricLogKey];
    const sourceInfo = soureInfo?.[entityType]?.[source] || source;
    logConfig &&
      buriedBtnPoint({
        ...logConfig,
        extInfo: `${logConfig?.extInfo}-${sourceInfo}-${metricname}`,
      });

    // 更新url参数，可视化指标
    updateURLSearchParams?.({ [URL_CHART_METRIC]: value });
    // if (value === 'est_price') {
    //   if (onChartTypeChange instanceof Function) {
    //     onChartTypeChange('line');
    //   }
    // }
  };

  const chageChartType = (metric: string) => {
    switch (metric) {
      case 'alinea__est_price':
      case 'alinea__weighted_price':
        handleChartMetricType('line');
        break;
      default:
        handleChartMetricType('bar');
        break;
    }
  };

  const steamSalesList = useMemo(
    () =>
      SteamSalesList?.map((item) => ({
        ...item,
        text: formatMessage({ id: item?.text }),
      })),
    [SteamSalesList, locale],
  );

  const isNotSuitable = useMemo(() => {
    if (pageId === 'SteamSales') {
      if (
        (chartType === 'line' &&
          ['alinea__players_by_country', 'alinea__playtime', 'alinea__steamfollowers'].includes(metricSegVal)) ||
        (chartType === 'pie' && metricSegVal === 'alinea__players_by_country')
      ) {
        setNoSuitableMsg(formatMessage({ id: 'dbi_metric_not_suitable' }));
        return true;
      }
      setNoSuitableMsg(formatMessage({ id: 'common_nodata' }));
      return false;
    }
    return false;
  }, [chartType, metricSegVal]);

  return (
    <>
      <div className="card-flex">
        <div className="card-title">
          {/* 指标筛选器 */}
          {pageId === 'SteamSales' ? (
            <div className="retention-segment">
              <Segment
                value={metricSegVal}
                onChange={(value) => {
                  chageChartType(value);
                  setChartLoading(true);
                  setMetricSegVal(value);
                  const metricObj = SteamSalesList?.find((item: any) => item.value === value) || {
                    text: '',
                  };
                  setMetricSegValText(metricObj?.text);
                  dispatch({ type: `${DBI_TOPCHARTS}/setMetricValue`, payload: value });
                }}
                options={steamSalesList}
              />
            </div>
          ) : (
            <>
              {dataSourceMetricsOptions?.length > 1 && (
                <DataSourceMetricSelector
                  options={dataSourceMetricsOptions}
                  onChange={handleMetricChange}
                  metricValue={topchartsState.metricValue}
                  pageId={pageId}
                  loading={isVisualisLoading}
                />
              )}
            </>
          )}
          {/* <ArrowdownText isNew={true}
            sortedData={sortByNameValue}
            order={fetchParams?.order}
            sortByKey={sortByKey}
            dataSourcesColumns={dataSourcesColumns}
          /> */}
        </div>
      </div>

      {isVisualisLoading ? (
        <div style={{ height: visualLoadingHeight - 60 }}>
          <Loading />
        </div>
      ) : (
        <div className="card-line" ref={cardRef}>
          <ChartsIndex
            ref={chartsInstance}
            chartLoading={chartLoading}
            barOption={barOption}
            lineOption={lineOption}
            chartType={chartType}
            isNodata={isNotSuitable ? isNotSuitable : isNodata}
            pieOption={pieOption}
            nodataMsg={noSuitableMsg}
            pieDataHighIndex={pieDataHighIndex}
          />
        </div>
      )}
    </>
  );
};

export default connect((state: any) => ({
  topchartsState: state[DBI_TOPCHARTS],
}))(MetricsTableVisualis);
